import o from "./HeadingText.mjs";
import "clsx";
import "react";
export {
  o as default
};
